'use client';

import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { FC } from 'react';
import { ComponentFlexibleHeroBlock } from '$/(cms)/_modules/cmsService/types';

type RewardImageProps = {
  imageDesktop: ComponentFlexibleHeroBlock['imageDesktop'];
  imageMobile: ComponentFlexibleHeroBlock['imageMobile'];
  headline?: string;
};

export const RewardImage: FC<RewardImageProps> = ({
  imageDesktop,
  imageMobile,
  headline,
}) => {
  const desktopUrl = imageDesktop?.url;
  const mobileUrl = imageMobile?.url ?? desktopUrl;

  if (!desktopUrl && !mobileUrl) {
    return null;
  }

  return (
    <figure className="w-full">
      {mobileUrl && (
        <CmsImage
          unoptimized
          src={mobileUrl}
          alt={
            imageMobile?.alternativeText ??
            imageDesktop?.alternativeText ??
            headline ??
            ''
          }
          width={imageMobile?.width ?? imageDesktop?.width ?? 640}
          height={imageMobile?.height ?? imageDesktop?.height ?? 360}
          className="block w-full object-contain md:hidden"
          // Rendered only on mobile (hidden on >=md via md:hidden), so base size is enough.
          sizes={{ _: '100vw' }}
        />
      )}
      {desktopUrl && (
        <CmsImage
          unoptimized
          src={desktopUrl}
          alt={
            imageDesktop?.alternativeText ??
            imageMobile?.alternativeText ??
            headline ??
            ''
          }
          width={imageDesktop?.width ?? imageMobile?.width ?? 640}
          height={imageDesktop?.height ?? imageMobile?.height ?? 360}
          className="hidden w-full object-contain md:block"
        />
      )}
    </figure>
  );
};
